import React from 'react'

const MessagingPolicy = () => {
    return (
        <section className="terms">
            <div className="row">
                <h2>SMS MOBILE MESSAGING POLICY</h2>
            </div>

            <div className="row content">
                <div>
                    <p>Effective Date: January 2026</p>
                    
                    <p>merigold.care (“we,” “us,” or “our”) offers a mobile messaging program to facilitate communication between our users and independent support affiliates regarding orders, warehouse fulfillment, and product inquiries. By providing your phone number and opting in, you agree to the following terms:</p>
                    
                    <p><strong>Express Consent and Opt-In</strong></p>
                    <p>Consent to receive text messages is collected via verbal agreement during a recorded telephone consultation with one of our independent support affiliates or through an explicit web-form submission.</p>
                    <ul>
                        <li>By saying \"Yes\" or \"I agree\" during a support call, you provide express written consent to receive recurring transactional and conversational SMS/MMS messages from our affiliates.</li>
                        <li>Consent is not a condition of purchase. You are not required to opt-in to receive SMS as a condition of buying any products or services.</li>
                    </ul>
                    <p><strong>Program Description & Content</strong></p>
                    <p>Messages are sent by independent affiliates to provide:</p>
                    <ul>
                        <li>Order status and warehouse tracking updates.</li>
                        <li>Follow-up responses to your specific product inquiries.</li>
                        <li>Logistical coordination for product delivery.</li>
                        <li>Note: We do not send bulk marketing \"blasts.\" All messages are intended to be 1-on-1 and conversational.</li>
                    </ul>
                    <p><strong>Message Frequency</strong></p>
                    <p>Message frequency varies based on your interaction with the affiliate and the status of your order. Typically, you can expect 2 to 6 messages per order lifecycle.</p>
                    <p><strong>Cost</strong></p>
                    <p>merigold.care does not charge for this service. However, Message and Data Rates May Apply depending on your mobile carrier and service plan.</p>
                    <p><strong>How to Opt-Out (Stop):</strong></p>
                    <p>You may cancel the SMS service at any time. To stop receiving messages, text \"STOP\" to the mobile number you are communicating with</p>
                    <p>*All the above categories exclude text messaging originator opt-in data and consent; this information will not be shared with any third parties.</p>
                    <p>After this, you will no longer receive messages from that affiliate unless you re-initiate contact by texting \"START.\"</p>
                    <p><strong>How to Get Help</strong></p>
                    <p>If you are experiencing issues with the messaging program, you can reply with the keyword \"HELP\" for more assistance, or contact our support team directly at support@merigold.care</p>
                    <p><strong>Privacy and Data Sharing</strong></p>
                    <p>We value your privacy. Mobile information will not be shared with third parties or affiliates for marketing or promotional purposes.</p>
                    <p>*All the above categories exclude text messaging originator opt-in data and consent; this information will not be shared with any third parties.</p>
                    <p>Your data is used solely to facilitate the support and logistics services you requested.</p>
                    <p><strong>Supported Carriers</strong></p>
                    <p>Carriers are not liable for delayed or undelivered messages. Most major US and Canadian carriers are supported.</p>
                </div>
            </div>
        </section>
    )
}

export default MessagingPolicy;